var cov_2gkjappowv = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Popover/styles/index.js",
      hash = "69b9488d033de4b7fe31e1862b041184497b2d7f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Popover/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 5,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var popoverLess = {};
import genaration from '../../utils/classname';
export var popoverClass = (cov_2gkjappowv.s[0]++, genaration(popoverLess, 'popover'));